import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { Logo } from './Logo';
import { Sun, Moon } from 'lucide-react';
import { playPopSound } from '../utils/soundUtils';

export function Navbar() {
  const { isDarkMode, toggleDarkMode } = useTheme();

  const handleThemeToggle = () => {
    playPopSound('medium'); // Play sound effect
    toggleDarkMode();
  };

  return (
    <nav className={`fixed top-0 w-full ${isDarkMode ? 'bg-[#1C1C1C]/95' : 'bg-white/95'} backdrop-blur-sm z-50`}>
      <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
        <div className="transition-transform duration-300 hover:scale-105">
          <Logo />
        </div>
        
        <button
          onClick={handleThemeToggle}
          className={`p-2 rounded-lg ${
            isDarkMode ? 'bg-[#252525] text-gray-200' : 'bg-gray-100 text-gray-600'
          } transition-all duration-300 hover:scale-110 active:scale-95 hover:rotate-12`}
          aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
        >
          {isDarkMode ? (
            <Moon size={20} className="animate-fadeIn" />
          ) : (
            <Sun size={20} className="animate-fadeIn" />
          )}
        </button>
      </div>
    </nav>
  );
}